import { render, staticRenderFns } from "./FormCustomer.vue?vue&type=template&id=f09f9a90"
import script from "./FormCustomer.vue?vue&type=script&lang=js"
export * from "./FormCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports